import { render, staticRenderFns } from "./HistoryRecord.vue?vue&type=template&id=6e7ecb86&"
import script from "./HistoryRecord.vue?vue&type=script&lang=js&"
export * from "./HistoryRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryRecord.vue"
export default component.exports